<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { APP_CODE, APP_VERSION } from "$lib/env"
  import { deviceStore } from "$lib/stores/device-store.svelte"

  const device = $derived(deviceStore.device)

  const handleRefresh = () => {
    window.location.reload()
  }

</script>
<main class="relative flex h-full w-full flex-col items-center justify-center">
  <div class="absolute top-4 inset-e-4 text-end font-mono text-xs font-light text-gray-800">
    <div>{APP_CODE}-{APP_VERSION}</div>
    <div>{device.device_id.toUpperCase().substring(0, 16)}</div>
  </div>
  <section class="flex flex-col w-80 space-y-6 text-center">
    <div class="flex justify-center gap-2">
      <Button
        variant="outline"
        class="rounded-full"
        onclick={handleRefresh}>
        Muat Ulang
      </Button>
    </div>
  </section>
</main>